import React, { useState, useEffect } from "react";
import { Form, Empty, Button, Descriptions } from "antd";
import { connect } from "react-redux";
import { MerchantService } from "../../services";
import { handleApiExceptions, alertify } from "../../app_methods";
import { updateCurrentUserAction } from "../../redux/actions";
import { Text4 } from "../../styles";
import { MerchantBankAccountList } from "../MerchantBankAccount";


let MerchantBankAccount = (props) => {
    
    return (
        <div className="row">
			<div className="col-sm-12 col-md-12 col-lg-12">
				<MerchantBankAccountList />
			</div>
		</div>
    );
};


MerchantBankAccount = Form.create()(MerchantBankAccount);

const mapStateToProps = (state) => ({
	current_user: state.userReducer.current_user,
});

const mapDispatchToProps = (dispatch) => ({
	updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MerchantBankAccount);